import * as React from "react";
const SvgBarChart = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4 20V10H8V20H4ZM10 20V4H14V20H10ZM16 20V13H20V20H16Z", fill: "#5F5C71" }));
export default SvgBarChart;
